export type ActionLoteForm = 'REGISTER' | 'UPDATE'

export const actionLoteForm: Record<ActionLoteForm, ActionLoteForm> = {
  REGISTER: 'REGISTER',
  UPDATE: 'UPDATE',
}
